import { IStyle } from 'Styles';
import { FmlxButton, FmlxIcon } from 'fmlx-common-ui';
import React from 'react';
import './RMTable.scss';

interface Props {
  tableHeading: string;
  onClickAddBtn?: (e) => void;
  onClickRemoveBtn?: (e) => void;
  showAddButton?: boolean;
  showDeleteButton?: boolean;
  errorMessage?: string;
}

export const RMTableHeadingWithAddRemoveBtns = (props: Props) => {
  const {
    tableHeading,
    onClickAddBtn,
    onClickRemoveBtn,
    showAddButton = true,
    showDeleteButton = true,
    errorMessage,
  } = props;
  return (
    <>
      <div
        id={`controls-rmtableheadingwithaddremovebtns-action`}
        data-testid={`controls-rmtableheadingwithaddremovebtns-action`}
        className="rmtable-heading-actions"
      >
        <div
          id={`controls-rmtableheadingwithaddremovebtns-heading-${tableHeading}`}
          data-testid={`controls-rmtableheadingwithaddremovebtns-heading-${tableHeading}`}
          style={styles.heading}
        >
          {tableHeading}
        </div>
        <div
          id={`controls-rmtableheadingwithaddremovebtns-errormsg`}
          data-testid={`controls-rmtableheadingwithaddremovebtns-errormsg`}
          style={styles.error}
        >
          {errorMessage}
        </div>
        <div
          id={`controls-rmtableheadingwithaddremovebtns-btn-wrapper`}
          data-testid={`controls-rmtableheadingwithaddremovebtns-btn-wrapper`}
          className="d-flex"
        >
          {showDeleteButton && onClickRemoveBtn && (
            <FmlxButton
              id={`controls-rmtableheadingwithaddremovebtns-remove-btn`}
              data-testid={`controls-rmtableheadingwithaddremovebtns-remove-btn`}
              className="rm-table-heading-remove-btn"
              onClick={onClickRemoveBtn}
              type={FmlxButton.Type.BASIC}
              variant={FmlxButton.Variant.CONTAIN}
              withIcon={FmlxButton.WithIcon.START}
              size={FmlxButton.Size.SMALL}
              onlyIcon
              icon={
                <FmlxIcon
                  id={`controls-rmtableheadingwithaddremovebtns-remove-icon`}
                  data-testid={`controls-rmtableheadingwithaddremovebtns-remove-icon`}
                  name="Trash"
                />
              }
              withTooltip={false}
            />
          )}
          {showAddButton && onClickAddBtn && (
            <FmlxButton
              id={`controls-rmtableheadingwithaddremovebtns-add-btn`}
              data-testid={`controls-rmtableheadingwithaddremovebtns-add-btn`}
              className="rm-table-heading-add-btn ms-1"
              onClick={onClickAddBtn}
              type={FmlxButton.Type.POSITIVE}
              variant={FmlxButton.Variant.CONTAIN}
              withIcon={FmlxButton.WithIcon.START}
              size={FmlxButton.Size.SMALL}
              onlyIcon
              icon={
                <FmlxIcon
                  id={`controls-rmtableheadingwithaddremovebtns-add-icon`}
                  data-testid={`controls-rmtableheadingwithaddremovebtns-add-icon`}
                  name="AddCircle"
                />
              }
              withTooltip={false}
            />
          )}
        </div>
      </div>
    </>
  );
};

const styles: IStyle = {
  heading: {
    fontSize: '12px',
    fontWeight: '400px',
  },
  error: {
    fontSize: '12px',
    fontWeight: '400px',
    color: 'red',
    paddingLeft: '5px',
  },
};
